(() => {
  if (window.LeslisSearchEvents) return;
  const configElement = document.getElementById('LeslisSearchConfig');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const viewed = new WeakMap();
  const pending = new WeakMap();
  let sent = 0;

  function consentAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true &&
        window.Cookiebot?.consent?.statistics === true;
    } catch { return false; }
  }

  function isPreview() {
    return config.designMode || window.Shopify?.designMode === true ||
      window.Shopify?.theme?.role !== 'main' || new URL(window.location.href).searchParams.has('preview_theme_id');
  }

  function endpoint() {
    if (!config.endpoint) return null;
    try {
      const url = new URL(config.endpoint, window.location.origin);
      return url.origin === window.location.origin && url.pathname.startsWith('/apps/') ? url.toString() : null;
    } catch { return null; }
  }

  function cleanQuery(value) {
    const query = String(value || '').normalize('NFKC').replace(/[\u0000-\u001f\u007f]/g, '').trim().replace(/\s+/g, ' ').slice(0, 120);
    if (!query || /@|https?:\/\/|www\.|\d[\d\s()+.-]{6,}\d/i.test(query)) return null;
    return query;
  }

  function record(kind, data) {
    const destination = endpoint();
    if (!destination || isPreview() || !consentAllowed()) return false;
    const query = cleanQuery(data.query);
    if (!query) return false;
    const event = {
      version: 1,
      eventId: window.crypto.randomUUID(),
      kind,
      query,
      source: data.source,
      resultCount: Number.isFinite(Number(data.resultCount)) ? Math.max(0, Math.min(100000, Number(data.resultCount))) : null,
      productId: data.productId ? String(data.productId).replace(/\D/g, '').slice(0, 25) : null,
      productTitle: data.productTitle ? String(data.productTitle).slice(0, 200) : null,
      position: data.position ? Math.max(1, Math.min(10000, Number(data.position))) : null
    };
    const body = JSON.stringify(event);
    let queued = false;
    try { queued = navigator.sendBeacon?.(destination, new Blob([body], { type: 'text/plain;charset=UTF-8' })) === true; } catch {}
    if (!queued) {
      fetch(destination, { method: 'POST', body, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, keepalive: true, credentials: 'same-origin' }).catch(() => {});
    }
    sent += 1;
    return true;
  }

  function impression(element, source) {
    if (!element || document.visibilityState !== 'visible') return;
    if (source === 'predictive' && !element.closest('form')?.hasAttribute('results')) return;
    const query = element.dataset.leslisQuery;
    const key = `${query}|${element.dataset.leslisResultCount}|${element.dataset.leslisPage || 1}`;
    if (viewed.get(element) === key) return;
    if (record(source === 'predictive' ? 'suggestions_viewed' : 'results_viewed', {
      query, source, resultCount: element.dataset.leslisResultCount
    })) viewed.set(element, key);
  }

  document.addEventListener('leslis:search-rendered', (event) => {
    const form = event.target.closest('[data-leslis-search-form]');
    if (!form) return;
    clearTimeout(pending.get(form));
    pending.set(form, setTimeout(() => impression(form.querySelector('[data-leslis-predictive-results]'), 'predictive'), 800));
  });

  document.addEventListener('input', (event) => {
    const form = event.target.closest('[data-leslis-search-form]');
    if (form) clearTimeout(pending.get(form));
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const card = link?.closest('[data-leslis-product-id]');
    if (!card || !link.getAttribute('href')?.includes('/products/')) return;
    const results = card.closest('[data-leslis-predictive-results], [data-leslis-search-results]');
    if (!results) return;
    const source = results.hasAttribute('data-leslis-predictive-results') ? 'predictive' : 'results';
    impression(results, source);
    record('product_clicked', {
      query: results.dataset.leslisQuery,
      source,
      resultCount: results.dataset.leslisResultCount,
      productId: card.dataset.leslisProductId,
      productTitle: card.dataset.leslisProductTitle,
      position: card.dataset.leslisPosition
    });
  }, true);

  function recordCurrentPage() {
    document.querySelectorAll('[data-leslis-search-results]').forEach((element) => impression(element, 'results'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', recordCurrentPage, { once: true });
  else recordCurrentPage();
  document.addEventListener('visitorConsentCollected', recordCurrentPage);
  window.addEventListener('CookiebotOnAccept', recordCurrentPage);
  window.addEventListener('CookiebotOnConsentReady', recordCurrentPage);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') recordCurrentPage();
  });

  // The Shopify privacy API is not loaded automatically in every theme.
  // Load it for reading consent; the existing consent manager remains authoritative.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) recordCurrentPage();
      });
    } catch { /* Keep collection disabled when consent cannot be determined. */ }
  }

  window.LeslisSearchEvents = Object.freeze({
    status: () => ({ endpointConfigured: Boolean(endpoint()), preview: Boolean(isPreview()), consent: consentAllowed(), queuedEvents: sent })
  });
})();
